import React, { ChangeEvent } from 'react';
import { Country } from '../../utils/ContextProviders/appContextTypes';
import { buildCountriesSelect, buildStatesSelect, shouldSelectBeDisabled } from './shippingAddressUtils';
import styles from './ShippingAddress.module.scss';
import useValidateValue, { INVALID_CLASS } from '../../hooks/useValidateValue';

function Select(props: {
  countries: Country[],
  name: string,
  value: string,
  label: string,
  handleOnChange: (event: ChangeEvent<HTMLSelectElement>) => void,
  currentCountryCode: string,
}) {
  const {
    countries, value, handleOnChange, name, label, currentCountryCode,
  } = props;
  const { validationClass, validateValue } = useValidateValue();

  return (
    <>
      <label className={styles.label} htmlFor={name}>
        {label}
        <select
          className={`${styles.select} ${validationClass}`}
          name={name}
          value={value}
          onChange={(evt: ChangeEvent<HTMLSelectElement>) => {
            handleOnChange(evt);
            validateValue(name, evt.target.value);
          }}
          disabled={shouldSelectBeDisabled(name, countries, currentCountryCode)}
        >
          {name === 'shipCountry' ? buildCountriesSelect(countries) : buildStatesSelect(countries, currentCountryCode)}
        </select>
        {validationClass === INVALID_CLASS && (
        <p className={styles.inputError}>
          Enter Valid
          {' '}
          {label}
        </p>
        )}
      </label>
    </>
  );
}

export default Select;
